export const DEFAULT_COLOR = 'pine';
